import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateComponent } from '../../../redux/editorSlice';
import { useTranslation } from '../../../redux/TranslationHelper';

export interface FAQLogicReturn {
  // Props
  id: string;
  title: string;
  faqItems: Array<{
    question: string;
    answer: string;
  }>;
  titleStyle: React.CSSProperties;
  
  // State
  expandedItems: Record<number, boolean>;
  
  // Functions
  toggleItem: (index: number) => void;
  updateFAQItem: (index: number, field: string, value: string) => void;
  updateTitle: (newTitle: string) => void;
  
  // Utils
  t: (key: string) => string;
}

export const useFAQLogic = (props: any): FAQLogicReturn => {
  const { t } = useTranslation();
  const dispatch = useDispatch() as any;
  const [expandedItems, setExpandedItems] = useState<Record<number, boolean>>({});
  
  // Extract props with defaults
  const {
    id = '',
    title = t("자주하는질문"),
    faqItems = [],
    titleStyle = {},
  } = props.data || props;

  // 펼치기/접기 토글 함수
  const toggleItem = useCallback((index: number) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  }, []);
  
  // FAQ 항목 수정 함수
  const updateFAQItem = useCallback((index: number, field: string, value: string) => {
    const updatedItems = [...faqItems];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value
    };
    
    dispatch(updateComponent({
      id,
      changes: { faqItems: updatedItems }
    }));
  }, [dispatch, faqItems, id]);

  // 제목 수정 함수
  const updateTitle = useCallback((newTitle: string) => {
    dispatch(updateComponent({
      id,
      changes: { title: newTitle }
    }));
  }, [dispatch, id]);

  return {
    // Props
    id,
    title: title || t("자주하는질문"),
    faqItems,
    titleStyle,
    
    // State
    expandedItems,
    
    // Functions
    toggleItem,
    updateFAQItem,
    updateTitle,
    
    // Utils
    t
  };
};